// Upload token DAO — reads + writes for the `upload_tokens` table used by
// the "share mobile upload link" flow.

import { BaseDao, type SupabaseClient } from '../base.ts';

interface UploadTokenSummary {
  token: string;
  expires_at: string;
}

export class UploadTokenDao extends BaseDao<UploadTokenSummary> {
  protected readonly dependentResources = ['upload_tokens'];

  constructor(sb: SupabaseClient) {
    super(sb, 'upload_tokens');
  }

  /** Most recent non-expired token for a transaction, or null. */
  async findActiveForTransaction(transactionId: number): Promise<UploadTokenSummary | null> {
    const { data } = await this.sb
      .from('upload_tokens')
      .select('token, expires_at')
      .eq('transaction_id', transactionId)
      .gt('expires_at', new Date().toISOString())
      .order('created_at', { ascending: false })
      .limit(1)
      .single();
    return (data as UploadTokenSummary | null) ?? null;
  }

  async createForTransaction(transactionId: number, createdBy: string): Promise<UploadTokenSummary> {
    const { data, error } = await this.sb
      .from('upload_tokens')
      .insert({ transaction_id: transactionId, created_by: createdBy })
      .select('token, expires_at')
      .single();
    if (error) throw error;
    return data as UploadTokenSummary;
  }
}
